
import Header from "../components/Header";
import Footer from "../components/Footer";
import { NavLink } from "react-router-dom";
import React, { useState } from 'react';
import { postTransferCertificate } from '../Service/Api';
function TCIssued() {
    const [admission, setAdmission] = useState('');
    const [name, setName] = useState('');
    const [error, setError] = useState('');

    const handleAdmissionNoChange = (event) => {
        setAdmission(event.target.value);
        setError(''); // Clear error on user input
    };

    const handleFullNameChange = (event) => {
        setName(event.target.value);
        setError(''); // Clear error on user input
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!name || !admission) {
            setError('Please fill in all fields');
            return;
        }

        try {
            const response = await postTransferCertificate(name, admission);
            if (response) {
                console.log(response.data);
                // Potentially navigate or show success message
                fetch(`https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${response.data}`)
                    .then((response) => response.blob()) // Assuming the data is in a blob format; adjust if different
                    .then((blob) => {
                        // Create a link element, use it to download the blob
                        const url = window.URL.createObjectURL(blob);
                        const a = document.createElement('a');
                        a.style.display = 'none';
                        a.href = url;
                        a.download = 'tc.jpg'; // Set the file name and extension
                        document.body.appendChild(a);
                        a.click();
                        window.URL.revokeObjectURL(url);
                        // alert('Your download has started.');  // Optional: Notify the user
                    })
                    .catch(() => alert('Failed to download data.')); // Error handling
            }
        } catch (error) {
            console.error('Failed to post data', error);
            setError('Failed to process your request. Please try again later.');
        }
    };
    return (
        <>
            <Header />
            {/* Inner Slider */}
            <section class="inr-header">
                <div class="container">
                    <div class="inr-header-content">
                        <h1 class="title">TC Issued</h1>
                        <ul class="breadcrumb">
                            <li><NavLink to="/">Home</NavLink></li>
                            <li> TC Issued</li>
                        </ul>
                    </div>
                </div>
            </section>
            {/*  Inner Body */}
            <section className="innerBody">
                <div className="container  them-container">
                    <div className="row">
                        <div className="col-12">
                            <h1>TC Issued</h1>
                        </div>
                    </div>
                    <form onSubmit={handleSubmit}>
                        <div className="row g-4">
                            <div className="col-lg-6">
                                <div className="formfil">
                                    <div className="form-group">
                                        <label htmlFor="number">
                                            <p> Admission No. </p>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={admission}
                                            onChange={handleAdmissionNoChange}
                                            required
                                        />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="number">
                                            <p> Student Full Name </p>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={name}
                                            onChange={handleFullNameChange}
                                            required
                                        />
                                    </div>
                                    <div className="clr10"></div>
                                    <button
                                        type="submit"
                                        name="btnshwtcdetails"
                                        className="btn btn-warning"
                                    >
                                        View Details
                                    </button>
                                    {error && <p className="error">{error}</p>}
                                </div>
                            </div>
                            <div className="col-lg-6">
                                <iframe src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMNSB/public/pdf/TC-Sample.pdf#toolbar=0" width="100%" height="500"></iframe>
                            </div>
                        </div>
                    </form>
                </div>
            </section>
            <div className="clr100"></div>
            {/* Footer */}
            <Footer />
        </>
    )
}

export default TCIssued